// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AEMJ","colBig":"styles_colBig__3uB2b","colSmall":"styles_colSmall__1YQmc"};